import {
  EnrichmentRelation,
  EnrichmentResult,
} from 'src/app/shared/models/ai-search.interface';

export interface EnrichmentFormValues {
  sector: string;
  sectorAlphaId: string;
  city: string;
  countryAlphaId: string;
  isin: string;
  ceoName: string;
  surfaceForms: string[];
}

const ISIN_REGEX = /^[A-Z]{2}[A-Z0-9]{9}\d$/;

function findRelation(
  relations: EnrichmentRelation[],
  relationType: string,
): EnrichmentRelation | undefined {
  return relations.find((r) => r.relation === relationType);
}

function extractAlphaId(objectUri: string): string {
  const dotIndex = objectUri.indexOf('.');
  return dotIndex >= 0 ? objectUri.substring(dotIndex + 1) : objectUri;
}

function extractIsin(relations: EnrichmentRelation[]): string {
  const securityRelations = relations.filter(
    (r) => r.relation === 'identifiesSecurity',
  );
  for (const rel of securityRelations) {
    if (ISIN_REGEX.test(rel.object_value)) {
      return rel.object_value;
    }
  }
  return '';
}

function extractCeo(relations: EnrichmentRelation[]): string {
  const ceoRelation = relations.find((r) => r.relation === 'isCEOof');
  return ceoRelation?.object_value ?? '';
}

export function mapEnrichmentToFormValues(
  result: EnrichmentResult,
): EnrichmentFormValues {
  const relations = result.relations ?? [];
  const surfaceForms = (result.surface_forms ?? []).map(
    (sf) => sf.surface_form,
  );

  const sectorRelation = findRelation(relations, 'companyHasSector');
  const cityRelation = findRelation(relations, 'companyHasHeadquarterInCity');
  const countryRelation = findRelation(
    relations,
    'companyHasPrimaryLocationIn',
  );

  return {
    sector: sectorRelation?.object_value ?? '',
    sectorAlphaId: sectorRelation
      ? extractAlphaId(sectorRelation.object_uri)
      : '',
    city: cityRelation?.object_value ?? '',
    isin: extractIsin(relations),
    ceoName: extractCeo(relations),
    countryAlphaId: countryRelation
      ? extractAlphaId(countryRelation.object_uri)
      : '',
    surfaceForms,
  };
}
